import { render, staticRenderFns } from "./DegreeItem.vue?vue&type=template&id=82890522&scoped=true"
import script from "./DegreeItem.vue?vue&type=script&lang=js"
export * from "./DegreeItem.vue?vue&type=script&lang=js"
import style0 from "./DegreeItem.vue?vue&type=style&index=0&id=82890522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82890522",
  null
  
)

export default component.exports